import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import _ from 'lodash';
import qs from 'qs';
import BigPreLoader from 'components/Common/PreLoaders/BigPreLoader';
import UserOutputCashService from 'mt-react-common/modules/authUserOutputCash/services/UserOutputCashService/UserOutputCashService';

class ConfirmPayoutCustomerApprove extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      result: null
    };
  }

  componentDidMount() {
    const token = _.get(qs.parse(this.props.location.search.slice(1)), 'token');
    if (token) {
      this.resendCustomerApproveToken(token);
    }
  }

  resendCustomerApproveToken = token => {
    this.setState({ isLoadingResendCustomerApproveToken: true });
    UserOutputCashService.customerApprove(token).then(result => {
      if (result.status === 200) {
        this.setState({
          isLoading: false,
          result: result.data
        });
      } else {
        this.setState({
          isLoading: false
        });
      }
      console.log(result.data);
    });
  };

  render() {
    if (!this.state.result) {
      return <BigPreLoader />;
    }
    return (
      <div
        className="container page-container_sticky"
        style={{
          padding: '20px'
        }}
      >
        <article
          className={`panel ${
            this.state.result.success ? 'panel-success' : 'panel-danger'
          }`}
        >
          <div className="panel-heading text-center">
            <h3 className="panel-title">Подтверждение выплаты</h3>
          </div>
          <div className="panel-body">
            <p>
              {this.state.result.message}
              <p>
                Для перехода на сайт нажмите на{' '}
                <Link to="/main/my-balance/payout">ссылку</Link>.
              </p>
            </p>
          </div>
        </article>
      </div>
    );
  }
}

ConfirmPayoutCustomerApprove.propTypes = {
  location: PropTypes.shape().isRequired
};

export default withRouter(ConfirmPayoutCustomerApprove);



// WEBPACK FOOTER //
// ./src/lauoyts/Common/Confirm/ConfirmPayoutCustomerApprove/ConfirmPayoutCustomerApprove.js